import React, { SetStateAction } from "react";

export function calcPageCount(total: number, pageSize: number): number {
  return Math.floor(total / pageSize) + (total % pageSize === 0 ? 0 : 1);
}

export interface PaginationState {
  pageCount: number;
  /**
   * 0-based page index
   */
  pageIndex: number;
  setPageIndex: React.Dispatch<SetStateAction<number>>;
  /**
   * 1-based page _number_
   */
  pageNumber: number;

  startOffsetForPage: (pageIndex: number) => number;
}

export function usePaginationState(total: number, pageSize: number, startPage = 0): PaginationState {
  const [pageIndex, setPageIndex] = React.useState(startPage);
  const pageNumber = pageIndex + 1;
  const pageCount = calcPageCount(total, pageSize);
  const startOffsetForPage = (idx: number) => idx * pageSize;
  return {
    pageCount,
    pageIndex,
    setPageIndex,
    pageNumber,
    startOffsetForPage,
  };
}
